import {
  QR_CODE_SIZE_STAND_A5,
  QR_CODE_SIZE_STAND_5X8_INCH,
  QR_CODE_SIZE_STICKER_4X6_INCH,
  QR_CODE_SIZE_STICKER_325_INCH,
  QR_CODE_SIZE_ACRYLIC_SHEETS_4X4_INCH,
  NORMAL_QRCODE_TYPE,
  DISTRIBUTION_MODES,
} from '../../consts';
import { qrCodeServiceDomain } from '../../consts/third_party';
import { getPrepaidCardMaxBonusRatio, loadImage } from '../../utils/utils';
import { fittingStringEllipsis, drawRoundRect, generateQRCode, ELLIPSIS_TEXT } from '../../utils/drawLoyaltyQRCode';
import { FONT_FAMILY } from 'src/consts/fonts';

const standENBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_a5_en.svg`;
const standZHBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_a5_zh.svg`;
const stickerBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_sticker.svg`;
const standENBackgroundImageWithWifi = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_a5_en_wifi.svg`;
const standZHBackgroundImageWithWifi = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_a5_zh_wifi.svg`;
const stickerBackgroundImageWithWifi = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_sticker_wifi.svg`;
const enVersionstickerBackgroundImageWithWifi = `${process.env.ASSETS_PREFIX}/assets/qrcode/en_version_qr_bg_sticker_wifi.svg`;
const enVersionstickerBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/en_verion_qr_bg_sticker.svg`;
const scanENImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/scan_en.svg`;
const scanZHImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/scan_zh.svg`;
const fullENImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/full_en.svg`;
const fullZHImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/full_zh.svg`;
const noCashBackENImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/no_cashback_en.svg`;
const noCashBackZHImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/no_cashback_zh.svg`;
const noDiscountENImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/no_discount_en.svg`;
const noDiscountZHImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/no_discount_zh.svg`;
const prepaidCardBonusENImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/prepaidcard_bouns_en.svg`;
const prepaidCardBonusZHImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/prepaidcard_bouns_zh.svg`;
const prepaidCardNoBonusENImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/prepaidcard_no_bouns_en.svg`;
const prepaidCardNoBonusZHImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/prepaidcard_no_bouns_zh.svg`;
const wifiImage = `${process.env.ASSETS_PREFIX}/assets/loyalty/wifi.svg`;
const inch5X8StandENBackgroundImageWithWifi = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_inch_5x8_en_wifi.svg`;
const inch5X8StandZHBackgroundImageWithWifi = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_inch_5x8_zh_wifi.svg`;
const inch5X8StandENBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_inch_5x8_en.svg`;
const inch5X8StandZHBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_inch_5x8_zh.svg`;
const cm3x3StickerBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_cm_3x3.svg`;
const cm3x3StickerBlackBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_black_cm_3x3.svg`;
const cm3x3StickerWhiteBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_white_cm_3x3.svg`;
const enVersioncm3x3StickerBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/en_version_qr_bg_cm_3x3.svg`;
const enVersioncm3x3StickerBlackBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/en_version_qr_bg_black_cm_3x3.svg`;
const enVersioncm3x3StickerWhiteBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/en_version_qr_bg_white_cm_3x3.svg`;

const cm4x4StickerWhiteBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_cm_4x4_zh.svg`;
const enVersioncm4x4StickerWhiteBackgroundImage = `${process.env.ASSETS_PREFIX}/assets/qrcode/qr_bg_cm_4x4_en.svg`;

const DEMOLOGO = `${process.env.ASSETS_PREFIX}/assets/qrcode/TESTLOGO.png`;

const StandSize = {
  width: 420,
  height: 595,
};

const A5StandSize = {
  width: 420,
  height: 595,
};

const Inch_5X8_StandSize = {
  width: 360,
  height: 576,
};

const Inch_4X6_StickerSize = {
  width: 600,
  height: 900,
};

const CM_3X3_StickerSize = {
  width: 975,
  height: 975,
};

const CM_4X4_AcrylicSheetsSize = {
  width: 1200,
  height: 1200,
};

const StickerSize = {
  width: 600,
  height: 900,
};

const scale = 3;
const StandQRCodeSize = 224 * scale;
const Inch5x8StandQRCodeSize = 160 * scale;
const StickerQRCodeSize = 290 * scale;
const StandLogoSize = 60 * scale;
const StickerLogoSize = 80 * scale;
const AcrylicSheetsLogoSize = 90 * scale;

const LoyaltyQRCodeSize = 80 * scale;
const LoyaltyQRWrapperSize = 92 * scale;
const Loyalty5x8InchQRWrapperSize = 100 * scale;
const Loyaltyy5x8InchQRCodeSize = 88 * scale;
const LoyaltyLogoSize = 30 * scale;
const BottomLogoSize = 44 * scale;
const WifiImageSize = 30 * scale;

const CM3x3StickerQRCodeSize = 381 * scale;

const CM4x4AcrylicSheetsQRCodeSize = 482 * scale;

function drawRadialGradient({ ctx, width, height }) {
  ctx.save();
  const gradient = ctx.createRadialGradient(width * 0.5 * scale, 0, 0, width * 0.5 * scale, 0, height * scale);
  gradient.addColorStop(0, '#595966');
  gradient.addColorStop(1, '#1D1B2E');
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, width * scale, height * scale);
  ctx.restore();
}

function checkIsHasLoyaltyContract(restaurantInfo) {
  const { restaurant_contracts = [] } = restaurantInfo;
  return restaurant_contracts.find((_) => _.distribution_mode === DISTRIBUTION_MODES.LOYALTY);
}

async function drawNonLoyaltyStandQRCodeInChinese({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { wifi_ssid, wifi_password, foreign_name, name, logo_url } = restaurantInfo;
  const { width, height } = A5StandSize;

  let image;

  if (wifi_ssid) {
    image = await loadImage(standZHBackgroundImageWithWifi);
  } else {
    image = await loadImage(standZHBackgroundImage);
  }

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  // draw restaurant foreign name
  const font = `normal ${20 * scale}px ${FONT_FAMILY.PINGFANG_SC}`;
  const { text } = fittingStringEllipsis({
    context: ctx,
    str: foreign_name || name,
    maxWidth: (width - 40) * scale,
    font,
  });
  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.font = font;
  ctx.textAlign = 'center';
  ctx.fillText(text, width * 0.5 * scale, 188 * scale);
  ctx.restore();

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    // draw table name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold normal ${36 * scale}px/${36 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 222 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, StandQRCodeSize);
  let y = 241 * scale;

  if (qrCodeImage) {
    const x = (width * scale - StandQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, StandQRCodeSize, StandQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StandLogoSize) / 2;
      y += (StandQRCodeSize - StandLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StandLogoSize, StandLogoSize);
    }
  }

  if (!wifi_ssid) return;

  ctx.save();
  ctx.font = `normal ${14 * 3}px/${17 * 3}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, 64 * scale, 565 * scale, 200 * scale);
  ctx.fillText(`Password: ${wifi_password || ''}`, 64 * scale, 582 * scale, 864 * scale);
  ctx.restore();
}

async function drawNonLoyaltyStandQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { wifi_ssid, wifi_password, name, logo_url } = restaurantInfo;
  const { width, height } = StandSize;

  let image;

  if (wifi_ssid) {
    image = await loadImage(standENBackgroundImageWithWifi);
  } else {
    image = await loadImage(standENBackgroundImage);
  }

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  // draw restaurant name
  const font = `normal ${20 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  const { text } = fittingStringEllipsis({
    context: ctx,
    str: name || '',
    maxWidth: (width - 40) * scale,
    font,
  });
  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.font = font;
  ctx.textAlign = 'center';
  ctx.fillText(text, width * 0.5 * scale, 188 * scale);
  ctx.restore();

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    // draw table name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold normal ${36 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 222 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, StandQRCodeSize);
  let y = 241 * scale;

  if (qrCodeImage) {
    const x = (width * scale - StandQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, StandQRCodeSize, StandQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StandLogoSize) / 2;
      y += (StandQRCodeSize - StandLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StandLogoSize, StandLogoSize);
    }
  }

  if (!wifi_ssid) return;

  ctx.save();
  ctx.font = `normal ${14 * 3}px/${17 * 3}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, 64 * scale, 565 * scale, 200 * scale);
  ctx.fillText(`Password: ${wifi_password || ''}`, 64 * scale, 582 * scale, 864 * scale);
  ctx.restore();
}

async function drawNonLoyalty5X8InchStandQRCodeInChinese({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService } = taskData;
  const { wifi_ssid, wifi_password, foreign_name, name, logo_url } = restaurantInfo;
  const { width, height } = Inch_5X8_StandSize;

  let image;

  if (wifi_ssid) {
    image = await loadImage(inch5X8StandZHBackgroundImageWithWifi);
  } else {
    image = await loadImage(inch5X8StandZHBackgroundImage);
  }

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  // draw restaurant foreign name
  const font = `normal ${16 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  const { text } = fittingStringEllipsis({
    context: ctx,
    str: foreign_name || name,
    maxWidth: (width - 34) * scale,
    font,
  });
  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.font = font;
  ctx.textAlign = 'center';
  ctx.fillText(text, width * 0.5 * scale, 150 * scale);
  ctx.restore();

  if (!isQuickService) {
    // draw table name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold normal ${28 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 204 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, Inch5x8StandQRCodeSize);
  let y = 230 * scale;

  if (qrCodeImage) {
    const x = (width * scale - Inch5x8StandQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, Inch5x8StandQRCodeSize, Inch5x8StandQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StandLogoSize) / 2;
      y += (Inch5x8StandQRCodeSize - StandLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StandLogoSize, StandLogoSize);
    }
  }

  if (!wifi_ssid) return;

  ctx.save();
  ctx.font = `normal ${12 * 3}px/${14 * 3}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, 50 * scale, 477 * scale, 103 * scale);
  ctx.fillText(`Password: ${wifi_password || ''}`, 50 * scale, 492 * scale, 180 * scale);
  ctx.restore();
}

async function drawNonLoyalty5X8InchStandQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService } = taskData;
  const { wifi_ssid, wifi_password, name, logo_url } = restaurantInfo;
  const { width, height } = Inch_5X8_StandSize;

  let image;

  if (wifi_ssid) {
    image = await loadImage(inch5X8StandENBackgroundImageWithWifi);
  } else {
    image = await loadImage(inch5X8StandENBackgroundImage);
  }

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  // draw restaurant name
  const font = `normal ${16 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  const { text } = fittingStringEllipsis({
    context: ctx,
    str: name || '',
    maxWidth: (width - 34) * scale,
    font,
  });
  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.font = font;
  ctx.textAlign = 'center';
  ctx.fillText(text, width * 0.5 * scale, 150 * scale);
  ctx.restore();

  if (!isQuickService) {
    // draw table name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold normal ${28 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 204 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, Inch5x8StandQRCodeSize);
  let y = 230 * scale;

  if (qrCodeImage) {
    const x = (width * scale - Inch5x8StandQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, Inch5x8StandQRCodeSize, Inch5x8StandQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StandLogoSize) / 2;
      y += (Inch5x8StandQRCodeSize - StandLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StandLogoSize, StandLogoSize);
    }
  }

  if (!wifi_ssid) return;

  ctx.save();
  ctx.font = `normal ${12 * 3}px/${14 * 3}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, 50 * scale, 477 * scale, 103 * scale);
  ctx.fillText(`Password: ${wifi_password || ''}`, 50 * scale, 492 * scale, 180 * scale);
  ctx.restore();
}

async function drawNonLoyaltyStickerQRCode({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { wifi_ssid, wifi_password, name, foreign_name, logo_url } = restaurantInfo;
  const { width, height } = StickerSize;

  let image;

  if (wifi_ssid) {
    image = await loadImage(stickerBackgroundImageWithWifi);
  } else {
    image = await loadImage(stickerBackgroundImage);
  }

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  const maxWidth = (width - 40) * scale;
  const fontSize = 24 * scale;
  const restaurantNameY = 310 * scale;

  if (!foreign_name) {
    const font = `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    const { text } = fittingStringEllipsis({
      context: ctx,
      str: name,
      maxWidth,
      font,
    });
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = font;
    ctx.textAlign = 'center';
    ctx.fillText(text, width * 0.5 * scale, restaurantNameY);
    ctx.restore();
  } else {
    const { text, contentWith: nameContentWidth } = fittingStringEllipsis({
      context: ctx,
      str: name,
      maxWidth,
      font: `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`,
    });
    let nameText = text;
    let totalWidth = nameContentWidth;
    let foreignNameText;

    if (nameContentWidth <= maxWidth - fontSize) {
      const _maxWidth = maxWidth - nameContentWidth - fontSize;
      const { text, contentWith } = fittingStringEllipsis({
        context: ctx,
        str: foreign_name,
        maxWidth: _maxWidth,
        font: `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`,
      });
      foreignNameText = text;

      if (foreignNameText === ELLIPSIS_TEXT) {
        if (!nameText.includes(ELLIPSIS_TEXT)) {
          nameText += ELLIPSIS_TEXT;
          ctx.font = `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`;
          totalWidth += ctx.measureText(ELLIPSIS_TEXT).width;
        }

        foreignNameText = null;
      } else {
        totalWidth += contentWith;
      }
    }

    // draw restaurant name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    const left = (maxWidth - totalWidth) / 2;
    ctx.fillText(nameText, left, restaurantNameY);
    ctx.restore();

    if (foreignNameText) {
      ctx.save();
      ctx.fillStyle = '#ffffff';
      ctx.font = `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`;
      ctx.fillText(foreignNameText, left + nameContentWidth + fontSize, restaurantNameY);
      ctx.restore();
    }
  }

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${52 * scale}px/${52 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 410 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, StickerQRCodeSize);
  let y = 440 * scale;

  if (qrCodeImage) {
    const x = (width * scale - StickerQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, StickerQRCodeSize, StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2;
      y += (StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }

  if (!wifi_ssid) return;

  const offsetY = (height - 42) * scale;

  ctx.save();
  ctx.font = `normal ${18 * scale}px/${22 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, 86 * scale, offsetY);
  ctx.fillText(`Password: ${wifi_password || ''}`, 86 * scale, offsetY + 22 * scale);
  ctx.restore();
}

async function drawNonLoyaltyStickerQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { wifi_ssid, wifi_password, name, logo_url } = restaurantInfo;
  const { width, height } = StickerSize;

  let image;

  if (wifi_ssid) {
    image = await loadImage(enVersionstickerBackgroundImageWithWifi);
  } else {
    image = await loadImage(enVersionstickerBackgroundImage);
  }

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  const maxWidth = (width - 40) * scale;
  const fontSize = 24 * scale;
  const restaurantNameY = 310 * scale;
  const font = `normal ${fontSize}px/${fontSize}px ${FONT_FAMILY.PROXIMA_NOVA}`;

  const { text } = fittingStringEllipsis({
    context: ctx,
    str: name,
    maxWidth,
    font,
  });
  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.font = font;
  ctx.textAlign = 'center';
  ctx.fillText(text, width * 0.5 * scale, restaurantNameY);
  ctx.restore();

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${52 * scale}px/${52 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 410 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, StickerQRCodeSize);
  let y = 440 * scale;

  if (qrCodeImage) {
    const x = (width * scale - StickerQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, StickerQRCodeSize, StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2;
      y += (StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }

  if (!wifi_ssid) return;

  const offsetY = (height - 42) * scale;

  ctx.save();
  ctx.font = `normal ${18 * scale}px/${22 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, 86 * scale, offsetY);
  ctx.fillText(`Password: ${wifi_password || ''}`, 86 * scale, offsetY + 22 * scale);
  ctx.restore();
}

async function drawNonLoyalty3x3CMStickerQRCode({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { wifi_ssid, wifi_password, name, foreign_name, logo_url } = restaurantInfo;
  const { width, height } = CM_3X3_StickerSize;
  let image = await loadImage(cm3x3StickerBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${72 * scale}px/${72 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM3x3StickerQRCodeSize);
  let y = 415 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM3x3StickerQRCodeSize) / 2 + 20;
    ctx.drawImage(qrCodeImage, x, y, CM3x3StickerQRCodeSize, CM3x3StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2 + 20;
      y += (CM3x3StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }
}

async function drawNonLoyalty3x3CMStickerQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { wifi_ssid, wifi_password, name, foreign_name, logo_url } = restaurantInfo;
  const { width, height } = CM_3X3_StickerSize;

  let image = await loadImage(enVersioncm3x3StickerBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${72 * scale}px/${72 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM3x3StickerQRCodeSize);
  let y = 415 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM3x3StickerQRCodeSize) / 2 + 20;
    ctx.drawImage(qrCodeImage, x, y, CM3x3StickerQRCodeSize, CM3x3StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2 + 20;
      y += (CM3x3StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }
}

async function drawNonLoyalty3x3CMBlackBKStickerQRCode({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;
  const { width, height } = CM_3X3_StickerSize;

  let image = await loadImage(cm3x3StickerBlackBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${72 * scale}px/${72 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM3x3StickerQRCodeSize);
  let y = 415 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM3x3StickerQRCodeSize) / 2 + 20;
    ctx.drawImage(qrCodeImage, x, y, CM3x3StickerQRCodeSize, CM3x3StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2 + 20;
      y += (CM3x3StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }
}

async function drawNonLoyalty3x3CMBlackBKStickerQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;
  const { width, height } = CM_3X3_StickerSize;

  let image = await loadImage(enVersioncm3x3StickerBlackBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${72 * scale}px/${72 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM3x3StickerQRCodeSize);
  let y = 415 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM3x3StickerQRCodeSize) / 2 + 20;
    ctx.drawImage(qrCodeImage, x, y, CM3x3StickerQRCodeSize, CM3x3StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2 + 20;
      y += (CM3x3StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }
}

async function drawNonLoyalty3x3CMWhiteBKStickerQRCode({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;
  const { width, height } = CM_3X3_StickerSize;

  let image = await loadImage(cm3x3StickerWhiteBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#E00051';
    ctx.font = `bold ${72 * scale}px/${72 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM3x3StickerQRCodeSize);
  let y = 415 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM3x3StickerQRCodeSize) / 2 + 20;
    ctx.drawImage(qrCodeImage, x, y, CM3x3StickerQRCodeSize, CM3x3StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2 + 20;
      y += (CM3x3StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }
}

async function drawNonLoyalty3x3CMWhiteBKStickerQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;
  const { width, height } = CM_3X3_StickerSize;

  let image = await loadImage(enVersioncm3x3StickerWhiteBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#E00051';
    ctx.font = `bold ${72 * scale}px/${72 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM3x3StickerQRCodeSize);
  let y = 415 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM3x3StickerQRCodeSize) / 2 + 20;
    ctx.drawImage(qrCodeImage, x, y, CM3x3StickerQRCodeSize, CM3x3StickerQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - StickerLogoSize) / 2 + 20;
      y += (CM3x3StickerQRCodeSize - StickerLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, StickerLogoSize, StickerLogoSize);
    }
  }
}

async function draw4x4CMAcrylicSheetsQRCode({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;
  const { width, height } = CM_4X4_AcrylicSheetsSize;

  let image = await loadImage(cm4x4StickerWhiteBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);
  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#000000';
    ctx.font = `bold ${74 * scale}px/${74 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 380 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM4x4AcrylicSheetsQRCodeSize);
  let y = 428 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM4x4AcrylicSheetsQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, CM4x4AcrylicSheetsQRCodeSize, CM4x4AcrylicSheetsQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - AcrylicSheetsLogoSize) / 2;
      y += (CM4x4AcrylicSheetsQRCodeSize - AcrylicSheetsLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, AcrylicSheetsLogoSize, AcrylicSheetsLogoSize);
    }
  }
}

async function draw4x4CMAcrylicSheetsQRCodeInEnglish({ ctx, taskData }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;
  const { width, height } = CM_4X4_AcrylicSheetsSize;

  let image = await loadImage(enVersioncm4x4StickerWhiteBackgroundImage);

  ctx.drawImage(image, 0, 0, width * scale, height * scale);

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    ctx.save();
    ctx.fillStyle = '#000000';
    ctx.font = `bold ${74 * scale}px/${74 * 1.1 * scale}px ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.textAlign = 'center';
    ctx.fillText(tableName, width * 0.5 * scale, 350 * scale);
    ctx.restore();
  }

  // draw qr code
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, CM4x4AcrylicSheetsQRCodeSize);
  let y = 405 * scale;

  if (qrCodeImage) {
    const x = (width * scale - CM4x4AcrylicSheetsQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, CM4x4AcrylicSheetsQRCodeSize, CM4x4AcrylicSheetsQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - AcrylicSheetsLogoSize) / 2;
      y += (CM4x4AcrylicSheetsQRCodeSize - AcrylicSheetsLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, AcrylicSheetsLogoSize, AcrylicSheetsLogoSize);
    }
  }
}

async function drawPromotionContentInChinese({ ctx, taskData }) {
  const { loyaltySettings, prepaidCardSettings } = taskData;
  let { cash_back_ratio = 0, discount_ratio = 1 } = loyaltySettings || {};
  cash_back_ratio = parseInt(cash_back_ratio * 100);
  const discount = discount_ratio * 10;
  const hasDiscount = discount !== 10;
  const scanTextImage = await loadImage(scanZHImage);
  ctx.drawImage(scanTextImage, 67 * scale, 48 * scale, 285 * scale, 47 * scale);

  const discountFontSize = `${48 * scale}px`;
  const cashBackFontSize = `${46 * scale}px`;

  if (hasDiscount && cash_back_ratio > 0) {
    const fullTextImage = await loadImage(fullZHImage);
    ctx.drawImage(fullTextImage, 66 * scale, 128 * scale, 288 * scale, 178 * scale);
    ctx.save();
    ctx.fillStyle = '#FBDDB1';
    ctx.textAlign = 'center';
    ctx.font = `bold normal ${discountFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(String(discount), 273 * scale, 232 * scale, 50 * scale);
    ctx.font = `bold normal ${cashBackFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(`${cash_back_ratio}%`, 231 * scale, 282 * scale, 58 * scale);
    ctx.restore();
    return;
  }

  // no cashback
  if (hasDiscount && cash_back_ratio <= 0) {
    const noCashBackImage = await loadImage(noCashBackZHImage);
    ctx.drawImage(noCashBackImage, 66 * scale, 128 * scale, 288 * scale, 124 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${discountFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(String(discount), 273 * scale, 230 * scale);
    ctx.restore();
    return;
  }

  // no discount
  if (!hasDiscount && cash_back_ratio > 0) {
    const noDiscountImage = await loadImage(noDiscountZHImage);
    ctx.drawImage(noDiscountImage, 66 * scale, 128 * scale, 288 * scale, 124 * scale);
    ctx.save();
    ctx.fillStyle = '#FBDDB1';
    ctx.textAlign = 'center';
    ctx.font = `bold normal ${cashBackFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(`${cash_back_ratio}%`, 229 * scale, 231 * scale, 58 * scale);
    ctx.restore();
    return;
  }

  const maxRatio = getPrepaidCardMaxBonusRatio(prepaidCardSettings);

  if (maxRatio >= 0.01) {
    const bonusImage = await loadImage(prepaidCardBonusZHImage);
    ctx.drawImage(bonusImage, 66 * scale, 128 * scale, 288 * scale, 125 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal 130px "Avenir Next Condensed"`;
    ctx.fillText(`${Math.floor(maxRatio * 100)}%`, 310 * scale, 233 * scale, 60 * scale);
    ctx.restore();
    return;
  }

  const noBonusImage = await loadImage(prepaidCardNoBonusZHImage);
  ctx.drawImage(noBonusImage, 66 * scale, 128 * scale, 288 * scale, 125 * scale);
}

async function draw5x8InchPromotionContentInChinese({ ctx, taskData }) {
  const { loyaltySettings, prepaidCardSettings } = taskData;
  let { cash_back_ratio = 0, discount_ratio = 1 } = loyaltySettings || {};
  cash_back_ratio = parseInt(cash_back_ratio * 100);
  const discount = discount_ratio * 10;
  let hasDiscount = discount !== 10;
  const scanTextImage = await loadImage(scanZHImage);
  ctx.drawImage(scanTextImage, 50 * scale, 26 * scale, 260 * scale, 43 * scale);

  const discountFontSize = `${38 * scale}px`;
  const cashBackFontSize = `${36 * scale}px`;

  if (hasDiscount && cash_back_ratio > 0) {
    const fullTextImage = await loadImage(fullZHImage);
    ctx.drawImage(fullTextImage, 50 * scale, 86 * scale, 260 * scale, 165 * scale);
    ctx.save();
    ctx.fillStyle = '#FBDDB1';
    ctx.textAlign = 'center';
    ctx.font = `bold normal ${discountFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(String(discount), 238 * scale, 180 * scale, 46 * scale);
    ctx.font = `bold normal ${cashBackFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(`${cash_back_ratio}%`, 197 * scale, (180 + 48) * scale, 56 * scale);
    ctx.restore();
    return;
  }

  // no cashback
  if (hasDiscount && cash_back_ratio <= 0) {
    const noCashBackImage = await loadImage(noCashBackZHImage);
    ctx.drawImage(noCashBackImage, 50 * scale, 86 * scale, 260 * scale, 112 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${discountFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(String(discount), 238 * scale, 178 * scale, 45 * scale);
    ctx.restore();
    return;
  }

  // no discount
  if (!hasDiscount && cash_back_ratio > 0) {
    const noDiscountImage = await loadImage(noDiscountZHImage);
    ctx.drawImage(noDiscountImage, 50 * scale, 86 * scale, 260 * scale, 112 * scale);
    ctx.save();
    ctx.fillStyle = '#FBDDB1';
    ctx.textAlign = 'center';
    ctx.font = `bold normal ${cashBackFontSize} 'Avenir Next Condensed'`;
    ctx.fillText(`${cash_back_ratio}%`, 198 * scale, 177 * scale, 48 * scale);
    ctx.restore();
    return;
  }

  let maxRatio = getPrepaidCardMaxBonusRatio(prepaidCardSettings);
  if (maxRatio >= 0.01) {
    const bonusImage = await loadImage(prepaidCardBonusZHImage);
    ctx.drawImage(bonusImage, 50 * scale, 86 * scale, 260 * scale, 112 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal 125px "Avenir Next Condensed"`;
    ctx.fillText(`${Math.floor(maxRatio * 100)}%`, 270 * scale, 180 * scale, 55 * scale);
    ctx.restore();
    return;
  }

  const noBonusImage = await loadImage(prepaidCardNoBonusZHImage);
  ctx.drawImage(noBonusImage, 50 * scale, 86 * scale, 260 * scale, 112 * scale);
}

async function drawPromotionContentInEnglish({ ctx, taskData }) {
  const { loyaltySettings, prepaidCardSettings } = taskData;
  let { cash_back_ratio = 0, discount_ratio = 1 } = loyaltySettings || {};
  const hasDiscount = +discount_ratio !== 1;
  cash_back_ratio = parseInt(cash_back_ratio * 100);
  const discount = parseInt(100 - discount_ratio * 100);
  const scanTextImage = await loadImage(scanENImage);
  ctx.drawImage(scanTextImage, 64 * scale, 68 * scale, 289 * scale, 26 * scale);
  const discountFontSize = `${48 * scale}px`;
  const cashBackFontSize = `${24 * scale}px`;

  if (hasDiscount && cash_back_ratio > 0) {
    const fullTextImage = await loadImage(fullENImage);
    ctx.drawImage(fullTextImage, 66 * scale, 118 * scale, 288 * scale, 170 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${discountFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${discount}%`, 121 * scale, 228 * scale, 84 * scale);
    ctx.font = `bold normal ${cashBackFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${cash_back_ratio}%`, 99 * scale, 266 * scale, 35 * scale);
    ctx.restore();
    return;
  }

  // no cashback
  if (hasDiscount && cash_back_ratio <= 0) {
    const noCashBackImage = await loadImage(noCashBackENImage);
    ctx.drawImage(noCashBackImage, 66 * scale, 118 * scale, 288 * scale, 138 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${discountFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${discount}%`, 120 * scale, 228 * scale, 84 * scale);
    ctx.restore();
    return;
  }

  // no discount
  if (!hasDiscount && cash_back_ratio > 0) {
    const noDiscountImage = await loadImage(noDiscountENImage);
    ctx.drawImage(noDiscountImage, 66 * scale, 118 * scale, 288 * scale, 130 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${cashBackFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${cash_back_ratio}%`, 97 * scale, 215 * scale, 40 * scale);
    ctx.restore();
    return;
  }

  const maxRatio = Math.floor(getPrepaidCardMaxBonusRatio(prepaidCardSettings) * 100);

  if (maxRatio >= 1) {
    const bonusImage = await loadImage(prepaidCardBonusENImage);
    ctx.drawImage(bonusImage, 66 * scale, 118 * scale, 288 * scale, 130 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal 80px/80px "Avenir Next Condensed"`;
    ctx.fillText(`${maxRatio}%`, 246 * scale, 219 * scale, 50 * scale);
    ctx.restore();
    return;
  }

  const noBonusImage = await loadImage(prepaidCardNoBonusENImage);
  ctx.drawImage(noBonusImage, 66 * scale, 118 * scale, 288 * scale, 130 * scale);
}

async function draw5x8InchStandPromotionContentInEnglish({ ctx, taskData }) {
  const { loyaltySettings, prepaidCardSettings } = taskData;
  let { cash_back_ratio = 0, discount_ratio = 1 } = loyaltySettings || {};
  let hasDiscount = +discount_ratio !== 1;
  cash_back_ratio = parseInt(cash_back_ratio * 100);
  let discount = parseInt(100 - discount_ratio * 100);
  const scanTextImage = await loadImage(scanENImage);
  ctx.drawImage(scanTextImage, 51 * scale, 50 * scale, 260 * scale, 23 * scale);
  const discountFontSize = `${42 * scale}px`;
  const cashBackFontSize = `${20 * scale}px`;

  if (hasDiscount && cash_back_ratio > 0) {
    const fullTextImage = await loadImage(fullENImage);
    ctx.drawImage(fullTextImage, 50 * scale, 92 * scale, 259 * scale, 153 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${discountFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${discount}%`, 98 * scale, 190 * scale, 74 * scale);
    ctx.font = `bold normal ${cashBackFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${cash_back_ratio}%`, 76 * scale, 225 * scale, 35 * scale);
    ctx.restore();
    return;
  }

  // no cashback
  if (hasDiscount && cash_back_ratio <= 0) {
    const noCashBackImage = await loadImage(noCashBackENImage);
    ctx.drawImage(noCashBackImage, 50 * scale, 92 * scale, 259 * scale, 124 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${discountFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${discount}%`, 98 * scale, 190 * scale, 74 * scale);
    ctx.restore();
    return;
  }

  // no discount
  if (!hasDiscount && cash_back_ratio > 0) {
    const noDiscountImage = await loadImage(noDiscountENImage);
    ctx.drawImage(noDiscountImage, 50 * scale, 92 * scale, 259 * scale, 117 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal ${cashBackFontSize} "Avenir Next Condensed"`;
    ctx.fillText(`${cash_back_ratio}%`, 76 * scale, 180 * scale, 35 * scale);
    ctx.restore();
    return;
  }

  let maxRatio = Math.floor(getPrepaidCardMaxBonusRatio(prepaidCardSettings) * 100);

  if (maxRatio >= 1) {
    const bonusImage = await loadImage(prepaidCardBonusENImage);
    ctx.drawImage(bonusImage, 50 * scale, 92 * scale, 259 * scale, 117 * scale);
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = '#FBDDB1';
    ctx.font = `bold normal 80px/80px "Avenir Next Condensed"`;
    ctx.fillText(`${maxRatio}%`, 212 * scale, 184 * scale, 45 * scale);
    ctx.restore();
    return;
  }

  const noBonusImage = await loadImage(prepaidCardNoBonusENImage);
  ctx.drawImage(noBonusImage, 50 * scale, 92 * scale, 259 * scale, 117 * scale);
}

async function drawLoyaltyQRCode({ ctx, taskData, width }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    // draw table name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    const fontSize = `${36 * scale}px`;
    ctx.font = `bold normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.fillText(tableName, width * 0.5 * scale, 374 * scale);
    ctx.restore();
  }

  const x = (width * scale - LoyaltyQRWrapperSize) / 2;
  drawRoundRect({
    ctx,
    x,
    y: 390 * scale,
    width: LoyaltyQRWrapperSize,
    height: LoyaltyQRWrapperSize,
    radius: 8 * scale,
  });

  // draw qrcode
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, LoyaltyQRCodeSize);

  if (qrCodeImage) {
    const x = (width * scale - LoyaltyQRCodeSize) / 2;
    const y = 390 * scale + (LoyaltyQRWrapperSize - LoyaltyQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, LoyaltyQRCodeSize, LoyaltyQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - LoyaltyLogoSize) / 2;
      const y = 390 * scale + (LoyaltyQRWrapperSize - LoyaltyLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, LoyaltyLogoSize, LoyaltyLogoSize);
    }
  }
}

async function drawLoyalty5x8InchQRCode({ ctx, taskData, width }) {
  const { restaurantInfo, tableName, code, isQuickService, qrCodeType } = taskData;
  const { logo_url } = restaurantInfo;

  if (qrCodeType === NORMAL_QRCODE_TYPE && !isQuickService) {
    // draw table name
    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    const fontSize = `${32 * scale}px`;
    ctx.font = `bold normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
    ctx.fillText(tableName, width * 0.5 * scale, 305 * scale);
    ctx.restore();
  }

  const x = (width * scale - Loyalty5x8InchQRWrapperSize) / 2;
  drawRoundRect({
    ctx,
    x,
    y: 320 * scale,
    width: Loyalty5x8InchQRWrapperSize,
    height: Loyalty5x8InchQRWrapperSize,
    radius: 8 * scale,
  });

  // draw qrcode
  const qrCodeLink = `${qrCodeServiceDomain}?code=${code}`;
  const qrCodeImage = await generateQRCode(qrCodeLink, Loyaltyy5x8InchQRCodeSize);

  if (qrCodeImage) {
    const x = (width * scale - Loyaltyy5x8InchQRCodeSize) / 2;
    const y = 320 * scale + (Loyalty5x8InchQRWrapperSize - Loyaltyy5x8InchQRCodeSize) / 2;
    ctx.drawImage(qrCodeImage, x, y, Loyaltyy5x8InchQRCodeSize, Loyaltyy5x8InchQRCodeSize);
  }

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      const x = (width * scale - LoyaltyLogoSize) / 2;
      const y = 320 * scale + (Loyalty5x8InchQRWrapperSize - LoyaltyLogoSize) / 2;
      ctx.drawImage(logoImage, x, y, LoyaltyLogoSize, LoyaltyLogoSize);
    }
  }
}

function getBottomTextWithWidth({ ctx, taskData, fontSize, maxWidth }) {
  const { restaurantInfo } = taskData;
  const { name, foreign_name } = restaurantInfo;

  const { text: nameText, contentWith: nameWidth } = fittingStringEllipsis({
    context: ctx,
    str: name,
    maxWidth,
    font: `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`,
  });
  const { text: foreignNameText, contentWith: foreignNameWidth } = fittingStringEllipsis({
    context: ctx,
    str: foreign_name,
    maxWidth,
    font: `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`,
  });
  const textMaxWidth = Math.max(nameWidth, foreignNameWidth);

  return {
    nameText,
    foreignNameText,
    textMaxWidth,
  };
}

async function drawBottomContentWithWifiInfo({ ctx, taskData, width, fontSize }) {
  const wifiImg = await loadImage(wifiImage);
  let x = (20 - 3) * scale;
  ctx.drawImage(wifiImg, x, 554 * scale, WifiImageSize, WifiImageSize);

  const { restaurantInfo } = taskData;
  const { logo_url, wifi_ssid, wifi_password } = restaurantInfo;

  // wifi info
  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  x += WifiImageSize + 4 * scale;
  const wifiTextMaxWidth = width * 0.5 * scale - WifiImageSize - 4 * scale;
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, x, 564 * scale, wifiTextMaxWidth);
  ctx.fillText(`Password: ${wifi_password || ''}`, x, 582 * scale, wifiTextMaxWidth);
  ctx.restore();

  // restaurant names
  let maxWidth = width * 0.5 * scale - 20 * scale;

  if (logo_url) {
    maxWidth -= BottomLogoSize + 4 * scale;
  }

  const { nameText, foreignNameText, textMaxWidth } = getBottomTextWithWidth({ ctx, taskData, fontSize, maxWidth });
  const textX = width * scale - 20 * scale - textMaxWidth;

  if (logo_url) {
    const logoImage = await loadImage(logo_url);

    if (logoImage) {
      const logoX = textX - BottomLogoSize - 4 * scale;
      ctx.drawImage(logoImage, logoX, 546 * scale, BottomLogoSize, BottomLogoSize);
    }
  }

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(nameText, textX, 564 * scale);
  ctx.restore();

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(foreignNameText, textX, 582 * scale);
  ctx.restore();
}

async function draw5x8InchBottomContentWithWifiInfo({ ctx, taskData, width, fontSize }) {
  const wifiImg = await loadImage(wifiImage);
  let x = 10 * scale;
  ctx.drawImage(wifiImg, x, 460 * scale, WifiImageSize, WifiImageSize);

  const { restaurantInfo } = taskData;
  const { logo_url, wifi_ssid, wifi_password } = restaurantInfo;

  // wifi info
  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  x += WifiImageSize + 4 * scale;
  const wifiTextMaxWidth = width * 0.5 * scale - WifiImageSize - 4 * scale;
  ctx.fillText(`Wi-Fi: ${wifi_ssid}`, x, 474 * scale, wifiTextMaxWidth);
  ctx.fillText(`Password: ${wifi_password || ''}`, x, 488 * scale, wifiTextMaxWidth);
  ctx.restore();

  // restaurant names
  let maxWidth = width * 0.5 * scale - 20 * scale;

  if (logo_url) {
    maxWidth -= BottomLogoSize + 4 * scale;
  }

  const { nameText, foreignNameText, textMaxWidth } = getBottomTextWithWidth({ ctx, taskData, fontSize, maxWidth });
  const textX = width * scale - 10 * scale - textMaxWidth;

  if (logo_url) {
    const logoImage = await loadImage(logo_url);

    if (logoImage) {
      const logoX = textX - BottomLogoSize - 4 * scale;
      ctx.drawImage(logoImage, logoX, 454 * scale, BottomLogoSize, BottomLogoSize);
    }
  }

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(nameText, textX, 474 * scale);
  ctx.restore();

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(foreignNameText, textX, 488 * scale);
  ctx.restore();
}

async function drawBottomContentWithoutWifiInfo({ ctx, taskData, width, fontSize }) {
  const { restaurantInfo } = taskData;
  const { logo_url } = restaurantInfo;

  let maxWidth = width * scale - 20 * 2 * scale;
  const logoContentWidth = BottomLogoSize + 4 * scale;
  if (logo_url) maxWidth -= logoContentWidth;
  const { nameText, foreignNameText, textMaxWidth } = getBottomTextWithWidth({ ctx, taskData, fontSize, maxWidth });

  let fullWidth = textMaxWidth;
  if (logo_url) fullWidth += logoContentWidth;
  let x = (width * scale - fullWidth) / 2;

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      ctx.drawImage(logoImage, x, 546 * scale, BottomLogoSize, BottomLogoSize);

      x += logoContentWidth;
    }
  }

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(nameText, x, 564 * scale);
  ctx.restore();

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(foreignNameText, x, 582 * scale);
  ctx.restore();
}

async function draw5x8InchBottomContentWithoutWifiInfo({ ctx, taskData, width, fontSize }) {
  const { restaurantInfo } = taskData;
  const { logo_url } = restaurantInfo;

  let maxWidth = width * scale - 10 * 2 * scale;
  const logoContentWidth = BottomLogoSize + 4 * scale;
  if (logo_url) maxWidth -= logoContentWidth;
  const { nameText, foreignNameText, textMaxWidth } = getBottomTextWithWidth({ ctx, taskData, fontSize, maxWidth });

  let fullWidth = textMaxWidth;
  if (logo_url) fullWidth += logoContentWidth;
  let x = (width * scale - fullWidth) / 2;

  if (logo_url) {
    const logoImage = await loadImage(logo_url);
    if (logoImage) {
      ctx.drawImage(logoImage, x, 454 * scale, BottomLogoSize, BottomLogoSize);

      x += logoContentWidth;
    }
  }

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(nameText, x, 474 * scale);
  ctx.restore();

  ctx.save();
  ctx.font = `normal ${fontSize} ${FONT_FAMILY.PROXIMA_NOVA}`;
  ctx.fillStyle = '#1D1B2E';
  ctx.fillText(foreignNameText, x, 488 * scale);
  ctx.restore();
}

async function drawBottomContent({ ctx, taskData, width }) {
  const fontSize = `${12 * scale}px/${14 * scale}px`;
  const { restaurantInfo } = taskData;
  const { wifi_ssid } = restaurantInfo;

  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 541 * scale, width * scale, 54 * scale);
  ctx.restore();

  if (wifi_ssid) {
    await drawBottomContentWithWifiInfo({ ctx, fontSize, taskData, width });
    return;
  }

  await drawBottomContentWithoutWifiInfo({ ctx, fontSize, taskData, width });
}

async function draw5x8InchBottomContent({ ctx, taskData, width }) {
  const fontSize = `${12 * scale}px/${14 * scale}px`;
  const { restaurantInfo } = taskData;
  const { wifi_ssid } = restaurantInfo;

  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 450 * scale, width * scale, 54 * scale);
  ctx.restore();

  if (wifi_ssid) {
    await draw5x8InchBottomContentWithWifiInfo({ ctx, fontSize, taskData, width });
    return;
  }

  await draw5x8InchBottomContentWithoutWifiInfo({ ctx, fontSize, taskData, width });
}

async function drawLoyaltyQRCodeCommonContent({ ctx, taskData, width, height }) {
  await drawLoyaltyQRCode({ ctx, taskData, width });
  await drawBottomContent({ ctx, taskData, width, height });
}

async function drawLoyalty5x8InchQRCodeCommonContent({ ctx, taskData, width, height }) {
  await drawLoyalty5x8InchQRCode({ ctx, taskData, width });
  await draw5x8InchBottomContent({ ctx, taskData, width, height });
}

async function drawLoyaltyStandQRCodeInChinese({ ctx, taskData }) {
  const { width, height } = A5StandSize;
  drawRadialGradient({ ctx, width, height });
  await drawPromotionContentInChinese({ ctx, taskData });
  await drawLoyaltyQRCodeCommonContent({ ctx, taskData, width, height });
}

async function drawLoyalty5x8InchStandQRCodeInChinese({ ctx, taskData }) {
  const { width, height } = Inch_5X8_StandSize;
  drawRadialGradient({ ctx, width, height: 450 });
  await draw5x8InchPromotionContentInChinese({ ctx, taskData });
  await drawLoyalty5x8InchQRCodeCommonContent({ ctx, taskData, width, height });
}

async function drawLoyaltyStandQRCodeInEnglish({ ctx, taskData }) {
  const { width, height } = A5StandSize;
  drawRadialGradient({ ctx, width, height });
  await drawPromotionContentInEnglish({ ctx, taskData });
  await drawLoyaltyQRCodeCommonContent({ ctx, taskData, width, height });
}

async function drawLoyalty5x8InchStandQRCodeInEnglish({ ctx, taskData }) {
  const { width, height } = Inch_5X8_StandSize;
  drawRadialGradient({ ctx, width, height: 450 });
  await draw5x8InchStandPromotionContentInEnglish({ ctx, taskData });
  await drawLoyalty5x8InchQRCodeCommonContent({ ctx, taskData, width, height: 450 });
}

function getCanvas(size) {
  const canvas = document.createElement('canvas');
  let canvasSize = A5StandSize;
  switch (size) {
    case QR_CODE_SIZE_STAND_A5: {
      canvasSize = A5StandSize;
      break;
    }
    case QR_CODE_SIZE_STAND_5X8_INCH: {
      canvasSize = Inch_5X8_StandSize;
      break;
    }
    case QR_CODE_SIZE_STICKER_4X6_INCH: {
      canvasSize = Inch_4X6_StickerSize;
      break;
    }
    case QR_CODE_SIZE_STICKER_325_INCH: {
      canvasSize = CM_3X3_StickerSize;
      break;
    }
    case QR_CODE_SIZE_ACRYLIC_SHEETS_4X4_INCH: {
      canvasSize = CM_4X4_AcrylicSheetsSize;
      break;
    }
    default: {
      canvasSize = A5StandSize;
    }
  }
  const { width, height } = canvasSize;
  canvas.width = width * scale;
  canvas.height = height * scale;
  return canvas;
}

//A5 stand QRCode Poster
export async function drawA5StandQRCode(taskData) {
  const { restaurantInfo, size } = taskData;
  const hasLoyaltyContract = checkIsHasLoyaltyContract(restaurantInfo);
  const images = [];

  let hasLoyalty = hasLoyaltyContract;

  if (hasLoyalty) {
    let { loyaltySettings } = taskData;

    if (!loyaltySettings) {
      loyaltySettings = { cash_back_ratio: '0.00', discount_ratio: '1.00' };
    }

    const { prepaidCardSettings } = taskData;
    const { cash_back_ratio, discount_ratio } = loyaltySettings || {};
    hasLoyalty = +discount_ratio !== 1 || cash_back_ratio > 0 || !!prepaidCardSettings?.is_active;
  }
  if (hasLoyalty) {
    const canvas1 = getCanvas(size);
    const ctx1 = canvas1.getContext('2d');
    await drawLoyaltyStandQRCodeInEnglish({ ctx: ctx1, taskData });
    const image1 = canvas1.toDataURL();
    images.push(image1);
    const canvas2 = getCanvas(size);
    const ctx2 = canvas2.getContext('2d');
    await drawLoyaltyStandQRCodeInChinese({ ctx: ctx2, taskData });
    const image2 = canvas2.toDataURL();
    images.push(image2);
  } else {
    const canvas1 = getCanvas(size);
    const ctx1 = canvas1.getContext('2d');
    await drawNonLoyaltyStandQRCodeInEnglish({ ctx: ctx1, taskData });
    const image1 = canvas1.toDataURL();
    images.push(image1);
    const canvas2 = getCanvas(size);
    const ctx2 = canvas2.getContext('2d');
    await drawNonLoyaltyStandQRCodeInChinese({ ctx: ctx2, taskData });
    const image2 = canvas2.toDataURL();
    images.push(image2);
  }

  return images;
}

export async function drawStickerQRCode(taskData) {
  const canvas = getCanvas(taskData.size);
  const ctx = canvas.getContext('2d');
  const images = [];
  if (taskData.size == QR_CODE_SIZE_STICKER_4X6_INCH) {
    await drawNonLoyaltyStickerQRCode({ ctx, taskData });
    images.push(canvas.toDataURL());

    let canvasEnVersionBG = getCanvas(taskData.size);
    let canvasEnVersionBG_ctx = canvasEnVersionBG.getContext('2d');
    await drawNonLoyaltyStickerQRCodeInEnglish({ ctx: canvasEnVersionBG_ctx, taskData });
    images.push(canvasEnVersionBG.toDataURL());
  } else if (taskData.size == QR_CODE_SIZE_ACRYLIC_SHEETS_4X4_INCH) {
    let canvasWhitekkBG = getCanvas(taskData.size);
    let canvasWhitekkBG_ctx = canvasWhitekkBG.getContext('2d');
    await draw4x4CMAcrylicSheetsQRCode({ ctx: canvasWhitekkBG_ctx, taskData });
    images.push(canvasWhitekkBG.toDataURL());

    canvasWhitekkBG = getCanvas(taskData.size);
    canvasWhitekkBG_ctx = canvasWhitekkBG.getContext('2d');
    await draw4x4CMAcrylicSheetsQRCodeInEnglish({ ctx: canvasWhitekkBG_ctx, taskData });
    images.push(canvasWhitekkBG.toDataURL());
  } else {
    await drawNonLoyalty3x3CMStickerQRCode({ ctx, taskData });
    images.push(canvas.toDataURL());

    let canvasBlackkBG = getCanvas(taskData.size);
    let canvasBlackkBG_ctx = canvasBlackkBG.getContext('2d');
    await drawNonLoyalty3x3CMBlackBKStickerQRCode({ ctx: canvasBlackkBG_ctx, taskData });
    images.push(canvasBlackkBG.toDataURL());

    let canvasWhitekkBG = getCanvas(taskData.size);
    let canvasWhitekkBG_ctx = canvasWhitekkBG.getContext('2d');
    await drawNonLoyalty3x3CMWhiteBKStickerQRCode({ ctx: canvasWhitekkBG_ctx, taskData });
    images.push(canvasWhitekkBG.toDataURL());

    //pure english version
    await drawNonLoyalty3x3CMStickerQRCodeInEnglish({ ctx, taskData });
    images.push(canvas.toDataURL());

    canvasBlackkBG = getCanvas(taskData.size);
    canvasBlackkBG_ctx = canvasBlackkBG.getContext('2d');
    await drawNonLoyalty3x3CMBlackBKStickerQRCodeInEnglish({ ctx: canvasBlackkBG_ctx, taskData });
    images.push(canvasBlackkBG.toDataURL());

    canvasWhitekkBG = getCanvas(taskData.size);
    canvasWhitekkBG_ctx = canvasWhitekkBG.getContext('2d');
    await drawNonLoyalty3x3CMWhiteBKStickerQRCodeInEnglish({ ctx: canvasWhitekkBG_ctx, taskData });
    images.push(canvasWhitekkBG.toDataURL());
  }

  return images;
}

export async function draw5X8InchStandQRCode(taskData) {
  const { restaurantInfo, size } = taskData;
  const hasLoyaltyContract = checkIsHasLoyaltyContract(restaurantInfo);
  const images = [];

  let hasLoyalty = hasLoyaltyContract;

  if (hasLoyalty) {
    let { loyaltySettings } = taskData;

    if (!loyaltySettings) {
      loyaltySettings = { cash_back_ratio: '0.00', discount_ratio: '1.00' };
    }

    const { prepaidCardSettings } = taskData;
    const { cash_back_ratio, discount_ratio } = loyaltySettings || {};
    hasLoyalty = +discount_ratio !== 1 || cash_back_ratio > 0 || !!prepaidCardSettings?.is_active;
  }

  if (hasLoyalty) {
    const canvas1 = getCanvas(size);
    const ctx1 = canvas1.getContext('2d');
    await drawLoyalty5x8InchStandQRCodeInEnglish({ ctx: ctx1, taskData });
    const image1 = canvas1.toDataURL();
    images.push(image1);
    const canvas2 = getCanvas(size);
    const ctx2 = canvas2.getContext('2d');
    await drawLoyalty5x8InchStandQRCodeInChinese({ ctx: ctx2, taskData });
    const image2 = canvas2.toDataURL();
    images.push(image2);
  } else {
    const canvas1 = getCanvas(size);
    const ctx1 = canvas1.getContext('2d');
    await drawNonLoyalty5X8InchStandQRCodeInEnglish({ ctx: ctx1, taskData });
    const image1 = canvas1.toDataURL();
    images.push(image1);
    const canvas2 = getCanvas(size);
    const ctx2 = canvas2.getContext('2d');
    await drawNonLoyalty5X8InchStandQRCodeInChinese({ ctx: ctx2, taskData });
    const image2 = canvas2.toDataURL();
    images.push(image2);
  }

  return images;
}
